import growthBook from 'services/growthBook';

/**
 * Reads GrowthBook unified_account for Reserhub; safe when the global store or GrowthBook is unavailable (e.g. tests).
 * @returns {boolean|string|object|undefined}
 */
export function getUnifiedAccountFeatureForReserhub() {
  try {
    return growthBook.getGrowthBookFeature('unified_account');
  } catch {
    return undefined;
  }
}

/**
 * Whether `env.reserhub.account` turns on unified Reserhub account behavior.
 * Requires an object account with truthy `loginUrl` and `homeUrl`; `enabled: false` disables.
 * @param {object|null|undefined} account - Whitelabel `env.reserhub.account`.
 * @param {object} [options] - unifiedAccountFeature (GrowthBook).
 * @param {boolean|string|object|undefined} [options.unifiedAccountFeature] - GrowthBook `unified_account_{brand}` value.
 * @returns {boolean}
 */
export default function isReserhubUnifiedAccountEnabled(account, options = {}) {
  const { unifiedAccountFeature } = options;

  if (!account || typeof account !== 'object') return false;
  if (account.enabled === false || !account.loginUrl || !account.homeUrl) {
    return false;
  }

  // If account is enabled and does not use progressive rollout, unified account is enabled.
  if (!account.progressiveRollout) {
    return true;
  }

  // If account uses progressive rollout, unified account is enabled only if GrowthBook feature is truthy.
  if (account.progressiveRollout === true && !unifiedAccountFeature) {
    return false;
  }

  return true;
}
